@if (data.icon) {
	<g-icon class="icon" [icon]="data.icon" fixedWidth size="lg" />
}
<div class="content">
	<div class="title" data-cy="toastTitle">{{ data.title }}</div>
	@if (data.body) {
		<div class="body" data-cy="toastBody">{{ data.body }}</div>
	}
</div>
@if (data.action) {
	<button
		mat-button
		class="action mat-button-dismiss"
		data-cy="toastAction"
		(click)="data.onAction?.()"
		>{{ data.action }}</button
	>
}
